import authService from './authService';
import SecureCookieManager from '../utils/secureCookie';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function createCompliance(complianceData:any) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance`, {
        method: 'POST',
        body: JSON.stringify(complianceData),
      });

      if (!response.ok) {
        throw new Error('Failed to create compliance');
      }

      const result = await response.json();
      return result;
    } catch (error:any) {
      console.error('Error creating compliance:', error);
      throw new Error(error);
    }
};



export async function getCompliance(query:string, perPage:number, pageNo:number) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to get compliance');
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching compliance:', error);
      throw new Error('Error fetching compliance');
    }
}


export const updateCompliance = async (id: string, data: any) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance/updatecomplaince/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update compliance');
    }

    return await response.json();
  } catch (error: any) {
    console.error('Error updating compliance:', error);
    throw error.message || 'Failed to update compliance';
  }
};



export async function deleteCompliance(id: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete compliance');
    }
    // Only parse JSON if there is content
    const text = await response.text();
    if (text) {
      return JSON.parse(text);
    }
    // If no content, assume success
    return { success: true };
  } catch (error) {
    console.error('Error deleting compliance:', error);
    throw new Error('Error deleting compliance');
  }
}


export async function createBareedyMessage(messageData: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/bareedy`, {
      method: 'POST',
      body: JSON.stringify(messageData),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to create bareedy message');
    }

    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error creating bareedy message:', error);
    throw new Error(error);
  }
}


export async function uploadBareedyFiles(files: File[], bareedyId: string) {
  const formData = new FormData();
  files.forEach(file => formData.append('files', file));
  formData.append('bareedyId', bareedyId);
  const headers: any = {};
  const token = SecureCookieManager.getAuthToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  try {
    const response = await authService.apiCall(`${BASE_URL}/upload/bareedy-files`, {
      method: 'POST',
      body: formData,
      headers
    });
    return response;
  } catch (error: any) {
    console.error('Error uploading files:', error);
    throw new Error('Error uploading files');
  }
}


export async function getBareedyMessages(perPage: number = 10, pageNo: number = 0) {
  const token = SecureCookieManager.getAuthToken();
  const headers: any = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  try {
    const response = await authService.apiCall(`${BASE_URL}/bareedy?perPage=${perPage}&pageNo=${pageNo}`, {
      method: 'GET',
      headers
    });
    if (!response.ok) {
      throw new Error('Failed to fetch bareedy messages');
    }
    return await response.json();
  } catch (error: any) {
    console.error('Error fetching bareedy messages:', error);
    throw new Error('Error fetching bareedy messages');
  }
}


